import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';


@Injectable()
export class EnrolmentRedirectGuard  {
  router = inject(Router);


  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const originalRequestUrl = state.url;

    if (originalRequestUrl.indexOf('/enrolment') !== -1) {
      const url = originalRequestUrl.replace('/enrolment', '/enrollment');

      return this.router.parseUrl(url);
    }

    return this.router.createUrlTree(['/notfound']);
  }

}
